// @flow

import type { Dispatch } from 'redux';
import type { SetActiveLanguage, ActiveLanguage } from './types';
import { SET_ACTIVE_LANGUAGE } from './constants';
import { getActiveLanguage } from './selectors';
import { setCookie } from '../../helpers';

export const setActiveLanguage = (language: ActiveLanguage): SetActiveLanguage => ({
  type: SET_ACTIVE_LANGUAGE,
  payload: {
    language,
  },
});

export const setActiveLanguageCookie = () => (dispatch: Dispatch<*>, getState: Function): void => {
  const activeLanguage = getActiveLanguage(getState());
  setCookie('language', activeLanguage, { expires: 365 });
};

export const switchActiveLanguage = (language: ActiveLanguage) => (
  dispatch: Dispatch<any>,
): void => {
  dispatch(setActiveLanguage(language));
  dispatch(setActiveLanguageCookie());
};


export default null;
